import { useState } from "react";
import { getAPIData } from '../Utils/commonApi';
import { useAuth } from "../Components/context/Auth";

const useCustomerTempAccess = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [sessionList, setSessionList] = useState([]);
  const [activeSession, setActiveSession] = useState(null);
  const {authTokens} = useAuth()

  function getTempAccessList(accountId) {
    setIsLoading(true);
    setSessionList([]);
    setActiveSession(null);
    getAPIData(`${1100}`, authTokens, {
      optionEnum98:accountId
    }, "CC_API")
      .then((response) => {
        setSessionList(response?.Session_List);
        const aSession = response?.Session_List?.find((s) => s.Status_Text === "Active");
        if (aSession) setActiveSession(aSession);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  return {
    isLoading,
    sessionList,
    activeSession,
    getTempAccessList
  }
}

export default useCustomerTempAccess;
